export default __webpack_public_path__ + "static/media/push28.c8bed502.gif";